<template>
    <div>
        <div class="tab">
            <div class="tabList">
                <div class="value">
                    <ul>
                        <li
                            v-for="(item, index) in tabList"
                            :key="index"
                            :class=" tabIndex == index ? 'active' : ''"
                            @click="tabChange(index)"
                        >
                            <span>{{ item }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabIndex:{
            type:Number|String,
            default:0
        },
        tabList:{
            type:Array,
            default:()=>([])
        }
    },
    data() {
        return {

        };
    },
    methods: {
        tabChange(index){
            this.$emit('tab-change',index)
        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
<style scoped lang="less">
@import "../style/index";
.tabList {
        .tabListStyle;
    }
</style>


// WEBPACK FOOTER //
// src/components/tabMenu.vue